import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=1bc3c207&scoped=true&"
import script from "./GlobalNavigation.vue?vue&type=script&lang=js&"
export * from "./GlobalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&id=1bc3c207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3c207",
  null
  
)

export default component.exports